/**
 * @author vishwadeep.kapoor
 * @Date: 2020-12-11 20:27:23
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2020-12-16 13:18:56
 */
import React, { PureComponent } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { Row, Col, Form, Input, Button } from 'antd';
import styled from 'styled-components';
import { shape, func } from 'prop-types';
// import { Link } from 'react-router-dom';
import { AppWrappperHOC } from '../../Root/HOC';
import { LandingContainer, FloatingLabel, HelmetWrapper, SubTitle } from '../../../components';
import ZaggleMap from './Map';
import endPoints from '../../../config/endPoints';
import { constants, validationRules } from '../../../devUtils';
import { SetContactUs } from '../../HeaderContainer/actions';

const { TextArea } = Input;
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 24 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 24 },
  },
};

const StyledContactUs = styled.section`
  .grayscale-filter{
    filter: grayscale(100%);
  }
  h1{
    font-family: 'Mulish',sans-serif;
    color: ${({ theme }) => theme.LandingBlack};
  }
  p{
    color: ${({ theme }) => theme.LandingBlack};
  }
  .landing{
    padding: 30px 0px;
    position: relative;
    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
      padding: 0px 0px;
      height:auto;
    };
  }
  .bg-gray{
    background: ${({ theme }) => theme.webGray};
    padding: 20px 40px 10px;
    border-radius: 6px;
  }
  b{
    color: ${({ theme }) => theme.primaryColor};
  }
  .grey-background{
    background: ${({ theme }) => theme.webGray};
  }
  .white-box{
      background: ${({ theme }) => theme.whiteColor};
      box-shadow: 3px 3px 20px #24415D0F;
      padding: 20px;
      border-radius: 10px;
  }
`;

class ContactUS extends PureComponent {
  constructor() {
    super();
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(evt) {
    evt.preventDefault();
    const { form: { validateFields, resetFields }, onInitContactUs, history } = this.props;
    validateFields((err, values) => {
      if (!err) {
        onInitContactUs({ ...values, platform: 'edge' }, { history });
        resetFields();
      }
    });
  }

  render() {
    const {
      form: { getFieldValue, getFieldDecorator },
      history: { location } = {},
    } = this.props;
    return (
      <StyledContactUs>
        <HelmetWrapper location={location} />
        <div className="gray-greadient">
          <section className="landing">
            <LandingContainer>
              <Row align="top" type="flex" justify="start" gutter={32}>
                <Col xs={24} sm={24} md={24} lg={10} xl={10} className="padding-t-3">
                  <p>Company</p>
                  <h1>Contact Us!</h1>
                  <p>Expand your business horizons, we’re here to help you</p>
                  <strong>New to Zaggle?</strong>
                  <p>Looking for a demo, have questions about products and pricing</p>
                  <Button
                    to={constants.LINK_ABOUT_US}
                    className="btn red-btn margin-t-1"
                    onClick={() => window.scroll(0, 940)}
                  >
                    Reach Us Now
                  </Button>
                </Col>
                <Col xs={24} sm={24} md={24} lg={14} xl={14}>
                  <div className="bg-gray">
                    <div className="text-center"><SubTitle fontWeight="900">Get in touch with us</SubTitle></div>
                    <Form layout="vertical" className="padding-b-4 margin-l-2 margin-r-2" onSubmit={this.handleSubmit}>
                      <Row align="middle" type="flex" gutter={16}>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                          <FloatingLabel label="First Name" value={getFieldValue('first_name')}>
                            <Form.Item className="margin-b-1">
                              {getFieldDecorator('first_name', {
                                rules: [validationRules.mandatory],
                              })(
                                <Input size="large" />
                              )}
                            </Form.Item>
                          </FloatingLabel>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                          <FloatingLabel label="Last Name" value={getFieldValue('last_name')}>
                            <Form.Item className="margin-b-1">
                              {getFieldDecorator('last_name', {
                                rules: [validationRules.mandatory],
                              })(
                                <Input size="large" />
                              )}
                            </Form.Item>
                          </FloatingLabel>
                        </Col>
                      </Row>
                      <FloatingLabel label="Job Title" value={getFieldValue('job_title')}>
                        <Form.Item className="margin-b-1" {...formItemLayout}>
                          {getFieldDecorator('job_title', {
                            rules: [validationRules.mandatory],
                          })(
                            <Input size="large" />
                          )}
                        </Form.Item>
                      </FloatingLabel>
                      <FloatingLabel label="Company Name" value={getFieldValue('company_name')}>
                        <Form.Item className="margin-b-1" {...formItemLayout}>
                          {getFieldDecorator('company_name', {
                            rules: [validationRules.mandatory],
                          })(
                            <Input size="large" />
                          )}
                        </Form.Item>
                      </FloatingLabel>
                      <FloatingLabel label="Email-ID" value={getFieldValue('email')}>
                        <Form.Item className="margin-b-1" {...formItemLayout}>
                          {getFieldDecorator('email', {
                            rules: [validationRules.email_valid, validationRules.email_field],
                          })(
                            <Input size="large" />
                          )}
                        </Form.Item>
                      </FloatingLabel>
                      <FloatingLabel label="Mobile Number" value={getFieldValue('phone')}>
                        <Form.Item className="margin-b-1" {...formItemLayout}>
                          {getFieldDecorator('phone', {
                            rules: [validationRules.mobile_number],
                          })(
                            <Input maxLength={10} size="large" />
                          )}
                        </Form.Item>
                      </FloatingLabel>
                      <FloatingLabel label="Number of employees*" value={getFieldValue('employee_range')}>
                        <Form.Item className="margin-b-1" {...formItemLayout}>
                          {getFieldDecorator('employee_range', {
                            rules: [validationRules.number_manadatory],
                          })(
                            <Input size="large" />
                          )}
                        </Form.Item>
                      </FloatingLabel>
                      <FloatingLabel label="I am looking for this product" value={getFieldValue('for_whom')}>
                        <Form.Item className="margin-b-1" {...formItemLayout}>
                          {getFieldDecorator('for_whom', {
                            rules: [validationRules.mandatory],
                          })(
                            <Input size="large" />
                          )}
                        </Form.Item>
                      </FloatingLabel>
                      <FloatingLabel label="If you have any query/comments?" value={getFieldValue('comment')}>
                        <Form.Item className="margin-b-1" {...formItemLayout}>
                          {getFieldDecorator('comment', {
                            rules: [validationRules.mandatory],
                          })(
                            <TextArea size="large" rows={3} />
                          )}
                        </Form.Item>
                      </FloatingLabel>
                      <div className="text-center">
                        <Button htmlType="submit" className="btn red-btn width-100">Submit</Button>
                      </div>
                    </Form>
                  </div>
                </Col>
              </Row>
            </LandingContainer>
          </section>
          <section className="padding-tb-5">
            <LandingContainer>
              <Row align="top" type="flex" justify="start" gutter={32}>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <img
                    src={endPoints.CONTACT_US_LANDING_IMAGE.URL}
                    alt={endPoints.CONTACT_US_LANDING_IMAGE.ALT}
                    className="width-100 grayscale-filter"
                  />
                </Col>
                <Col xs={24} sm={24} md={1} lg={1} xl={1}></Col>
                <Col xs={24} sm={24} md={11} lg={11} xl={11} className="padding-tb-2">
                  <SubTitle fontWeight="800" className="font-26">At Zaggle, we ensure to provide exceptional service. We’d love to hear from you.</SubTitle>
                  <p>Fill in the form and our product specialists will get back to you in two working days.</p>
                  <ul className="tick-list">
                    <li>Automate your workflow and expense management</li>
                    <li>24/7 team assistance</li>
                    <li>A customized platform for all your business needs</li>
                  </ul>
                  <SubTitle fontWeight="800" className="font-24 padding-t-2">Reach Leadership</SubTitle>
                  <p>If you are looking to reach out our leadership team for any questions or partnership or any assistance,
                    please drop a query to <b> corporate.marketing@zaggle.in</b>
                  </p>
                </Col>
              </Row>
            </LandingContainer>
          </section>
          <section className="grey-background padding-tb-4">
            <LandingContainer>
              <Row align="top" type="flex" justify="start" gutter={32}>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <SubTitle fontWeight="800" className="font-26">Sales Enquiries</SubTitle>
                  <p>If you are looking to understand how our products will fit with your organisation needs, fill in the form to schedule a demo. Want to get in touch with a sales executive right away, drop in a mail to</p>
                  <p>
                    <b>enquiries@zaggle.in</b>
                    <br />
                    <b>18605001231</b> - Save, Edge & other products
                    <br />
                    <b>18605003748</b> - Propel
                  </p>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <SubTitle fontWeight="800" className="font-26">Support Queries</SubTitle>
                  <p>Facing any concerns or issues while using our products. Don’t worry, we’re here for you. To contact support, drop in a mail to</p>
                  <p>
                    <b>care@zaggle.in </b>
                    <br />
                    <b>team@zaggle.in</b> - Propel
                    <br />
                    <b>18605001231</b> -  Save, Edge & other products
                    <br />
                    <b>18605003748</b> - Propel
                  </p>
                </Col>
              </Row>
            </LandingContainer>
          </section>
          <ZaggleMap />
        </div>
      </StyledContactUs>
    );
  }
}

ContactUS.propTypes = {
  form: shape({}).isRequired,
  history: shape({}).isRequired,
  onInitContactUs: func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  onInitContactUs: (payload, otherParams = {}) => dispatch(SetContactUs(payload, otherParams)),
});

const mapStateToProps = createStructuredSelector({
});


const FORM_WRAPPER = Form.create({ name: 'normal_login' })(ContactUS);
export { ContactUS, FORM_WRAPPER };
export default connect(mapStateToProps, mapDispatchToProps)(AppWrappperHOC(FORM_WRAPPER));



// WEBPACK FOOTER //
// client/containers/StaticPages/ContactUS/index.js